export default __webpack_public_path__ + "static/media/flash13.c1f1d30d.png";